/* eslint-disable @typescript-eslint/naming-convention */
export interface BadgeOptions {
    color?: string;
    backgroundColor?: string;
    type: badgeColorCode | string;
    displayKey?: string;
    displayName: string | number;
    displayType?: string;
    extraClass?: string;
    icon?: string;
    enableClick?: boolean;
    url?: boolean;
}

export interface eventEmitter {
    isClicked?: boolean;
}

export enum badgeColorCode {
    'LOW' = '#02B875',
    'MEDIUM'= '#3498db',
    'HIGH'= '#f39c12',
    'URGENT'= '#e74c3c',
    'NEW'= '#02B875',
    'SCHEDULED'= '#1abc9c',
    'ON_MY_WAY'= '#3498db',
    'STARTED'= '#9b59b6',
    'ON_HOLD'= '#e67e22',
    'COMPLETED'= '#27ae60',
    'CANNOT_COMPLETE'= '#c0392b',
    'INCOMPLETE'= '#c0392b',
    'CLOSED'= '#16a085',
    'FAILED'= '#c0392b',
    'OTHER'= '#34495e',
    'OTHERS'= '#34495e',
    'FOLLOW_UP'= '#000000',
    'FOLLOW_UP_SAME_JOB'= '#000000',
    'DRAFT'= '#f39c12',
    'AWAIT_RESPONSE'= '#3498db',
    'REQUEST_CHANGE'= '#8E44AD',
    'APPROVED'= '#27ae60',
    'DECLINED'= '#c0392b',
    'ARCHIVED'= '#2C3E50',
    'CANCELED'= '#c0392b',
    'CANCELLED'= '#c0392b',
    'ON_PROGRESS'= '#c0392b',
    'IN_PROGRESS'= '#9b59b6',
    'IN_TRANSIT'= '#0172CB',
    'INITIATED'= '#3498db',
    'INPROGRESS'= '#c0392b',
    'AWAIT_PAYMENT'= '#3498db',
    'YET_TO_SEND'= '#f39c12',
    'PAID'= '#27ae60',
    'PARTIALLY_PAID'= '#e67e22',
    'BAD_DEBT'= '#c0392b',
    'REJECTED'= '#c0392b',
    'AWAIT_APPROVAL'= '#f39c12',
    'AWAIT_CUSTOMER_APPROVAL'= '#e67e22',
    'CUSTOMER_APPROVED'= '#27ae60',
    'CUSTOMER_REJECTED'= '#c0392b',
    'EXPIRED'= '#c0392b',
    'ACTIVE'= '#166534',
    'INACTIVE'= '#991b1b',
    'PRIMARY'= '#4f46e5',
    'TAG'= '#374151',
    'ROUNDEDTAG'= '#64748B',
    'SUCCESS'= '#27ae60',
    'DANGER'='#c0392b',
    'VOIDED'='#777777',
    'AUTHORIZED'= '#3498db',
    'REFUNDED'= '#f39c12',
    'PREQUALIFIED'= '#27ae60',
    'SETTLED'= '#27ae60',
    'LOAN TERMS ACCEPTED'= '#8E44AD',
    'LOAN CONFIRMED'= '#3498db',
    'READY_TO_INSTALL'= '#337AB7',
    'INSTALLED' = '#5CB85C',
    'UNDER_SERVICE' = '#F0AD4E',
    'REMOVED'='#D9534F',
    'OBSOLETE'= '#D9534F',
    'DETAILS_TAB_COUNT'='#005AA3',
    'OPEN'= '#166534',
    'PRIVATE' = '#252A31',
    'PUBLIC' = '#0172CB',
    'INTERNAL' = '#E98305',
    'ONLINE' = '#5CB85C',
    'OFFLINE' = '#D9534F',
    'NEED_REPAIR' = '#F0AD4E',
    'FAILURE'= '#c0392b',
    'PARTIAL_IMPORT' = '#c0392b',
    'DISPUTED' = '#c0392b',
    'PARTIALLY_REFUNDED'= '#e67e22',
    'YET_TO_VERIFY'= '#F0AD4E'
}
